export default "__VITE_ASSET__Cg48Lf5g__"